import { Routes } from '@angular/router';

import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { AccountLayoutComponent } from './layout/account-layout/account-layout.component';

import { RegisterLoginComponent } from './component/register-login/register-login.component';

import { HomePageComponent } from './page/home-page/home-page.component';
import { DashboardPageComponent } from './page/dashboard-page/dashboard-page.component';
import { CommercePageComponent } from './page/commerce-page/commerce-page.component';
import { SalesTpvPageComponent } from './page/sales-tpv-page/sales-tpv-page.component';
import { CasefileCotejoPageComponent } from './page/casefile-cotejo-page/casefile-cotejo-page.component';
import { BuroPageComponent } from './page/buro-page/buro-page.component';
import { LoginFormComponent } from './form/form/login-form/login-form.component';
import { RegisterFormComponent } from './form/form/register-form/register-form.component';
import { AvisoPageComponent } from './page/aviso-page/aviso-page.component';
import { TerminoPageComponent } from './page/termino-page/termino-page.component';
import { ConfirmationPageComponent } from './page/confirmation-Page/confirmation-page.component';
import { privacidadPageComponent } from './page/privacidad-page/privacidad-page.component';
import { TerminoRegistroPageComponent } from './page/termino-registro-page/termino-registro-page.component';
import { recoverPageComponent } from './page/recover-page/recover-page.component';
import { EdicionRegistroComponent } from './page/edicion-registro/edicion-registro';
import { SatPageComponent } from './page/sat-page/sat-page.component';


export const routes: Routes = [

  {
    path: 'account', component: AccountLayoutComponent,
    children: [
      { path: '', component: LoginFormComponent },
      { path: 'register', component: RegisterFormComponent },
    ]
  },

  {
    path: '', component: MainLayoutComponent,
    children: [
      { path: '', component: HomePageComponent },
      { path: 'code/:code', component: HomePageComponent },
      { path: 'sat/:code', component: SatPageComponent },
      { path: 'dashboard', component: DashboardPageComponent },
      { path: 'commerce', component: CommercePageComponent },
      { path: 'sales', component: SalesTpvPageComponent },
      { path: 'casefile', component: CasefileCotejoPageComponent },
      { path: 'buro', component: BuroPageComponent },
      { path: 'aviso', component: AvisoPageComponent },
      { path: 'termino', component: TerminoPageComponent },
      { path: 'privacidad', component: privacidadPageComponent },
      { path: 'fin', component: TerminoRegistroPageComponent },
      { path: 'confirmation/:email', component: ConfirmationPageComponent },
      { path: 'recover/:idUser', component: recoverPageComponent },
      { path: 'edicion/:idUser', component: EdicionRegistroComponent }

    ]
  }
  
]



// WEBPACK FOOTER //
// ./src/app/app.route.ts